export function logs (...args: any[]) {
  console.log('[升级任务调度器]', ...args)
}

type IEventName =
  | 'pending'
  | 'start'
  | 'paused'
  | 'resume'
  | 'progress'
  | 'success'
  | 'error'
  | 'scheduled'
  | 'finished'
  | 'timeout'

export const EVENT_NAMES: IEventName[] = [
  'pending',
  'start',
  'paused',
  'resume',
  'progress',
  'success',
  'error',
  'scheduled',
  'finished',
  'timeout',
]
export const EVENT_NAME_PREFIX = ''

export const enum TASK_ERROR_CODE {
  NO_ERROR = 0, // 没有异常
  NETWORK_ERROR, // 网络异常
  NOT_REPLY, // 指令超时
  DOWNLOAD_ERROR, // 下载失败
  INSTALL_ERROR, // 安装失败
  LAUNCH_ERROR, // 服务未正常启动
  TIMEOUT_ERROR, // 更新超时
  OTHER, // 其他类型错误
}

export const enum TASK_STATE_CODE {
  UNKNOW = 0, // 未知
  PENDING, // 正在排队
  SENDING, // 指令已发送，等待确认
  ARRIVED, // 指令已送达，等待更新任务执行
  UPDATING, // 已经在更新队列中
  DOWNLOADING, // 正在下载安装包
  INSTALLING, // 正在安装
  READY, // 验证中
  LAUNCHING, // 正在启动服务
  COMPLETED, // 任务完成
  OTHER, // 其他类型
}

export interface ITriggerEventData {
  appid: string
  type?: TASK_STATE_CODE
  progress?: number
}

export interface IErrorEventData {
  appid: string
  type: TASK_ERROR_CODE
  error: Error
}

export const XOS_SYSTEM = 'xos'
export function getEvtNameFromType (type: IEventName) {
  return EVENT_NAME_PREFIX ? `${EVENT_NAME_PREFIX}$${type}` : type
}
